import { ReactComponent as LogoBlackIcon } from '@sketch/icons/logo-black-svg'
import styled from 'styled-components'

export const Logo = styled(LogoBlackIcon)`
  width: 32px;
  height: 32px;
  color: ${({ theme }) => theme.colors.background.primary.A};
`

export const Header = styled.div`
  margin: 24px;
  display: flex;
  height: 3rem;
  justify-content: space-between;
  align-items: center;
`

export const LeftSideLogoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex: 0 1 180px;
`

export const CenterBannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 0 0 auto;
  padding: 0 12px;
`

export const RightSideButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 0 1 180px;
`

export const FullWidthBannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 1 1 100%;
`
